module.exports = __webpack_public_path__ + "img/GAME_PICTURECORRECT.c8882f6f.png";